import { create } from 'zustand';

interface EditHubModalState {
  slug: string;
  isOpen: boolean;
  hub?: { serialNumber: string; pk: number };
  onEditHubModalClose: () => void;
  onEditHubModalOpen: (slug: string, hubId?: { serialNumber: string; pk: number }) => void;
}

export const useEditHubModalStore = create<EditHubModalState>(set => ({
  isOpen: false,
  slug: '',
  hubId: undefined,
  onEditHubModalClose: () => set({ isOpen: false, slug: '', hub: undefined }),
  onEditHubModalOpen: (slug: string, hub?: { serialNumber: string; pk: number }) => set({ isOpen: true, slug, hub }),
}));
